export default {
  title: 'Yhteystiedot ja synkronointi',
  labels: {
    occ_phone_number: 'Puhelinkeskuksen puhelinnumero',
    company_phone_number: 'Ravintolan puhelinnumero',
    has_google_business_sync: 'Synkronoi Google Businessin kanssa',
    has_foodamigos_sync: 'Synkronoi Foodamigos-palveluiden kanssa',
  },
  placeholders: {
    occ_phone_number: 'Valitse puhelinnumero listasta',
  },
};
